import styled from 'styled-components';

export const MobileWrap = styled.div`
	& .ant-input-group.ant-input-group-compact {
		display: flex;
	}
`;
